import { Pipe, PipeTransform } from '@angular/core';
import {VizixService} from "../../providers/vizix.service";

/**
 * Generated class for the ValidateSkuPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'validateSku',
})
export class ValidateSkuPipe implements PipeTransform {
  constructor(private vizixService: VizixService){
  }
  transform(value: string) {
    let regExp = new RegExp(this.vizixService.configurationApp.AppParametersConfiguration.SKUValidation.value);
    return regExp.test(value) ? value : "";
  }
}



// WEBPACK FOOTER //
// ./src/pipes/validate-tag/validate-sku.ts